var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/Pin"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("path",{"d":"M7.00000577,10.7166244 C7.00553223,14.7243213 10.7908219,14.7243213 12.5635878,20 C14.4086762,14.7146195 18.148505,14.7146195 18.1428034,10.5948203 C18.1385781,7.54180616 15.6023904,4.99238422 12.5796352,5.0000171 C9.47278041,5.00783389 6.99563518,7.54713958 7.00000577,10.7166244 Z","id":"path-1","key":2})]);
}

Pin.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = Pin;

Pin.default = Pin;
